/**
 * The environment of this build, from ONE source (#458): `VITE_ENV`, which
 * CI bakes into the staging and production images (deploy-app.yml). A local
 * `npm run dev` has none, so it is 'development'.
 *
 * Before, three places found it three ways: the URL of the API containing
 * "test" (SaramaPlayer), the host name (Layout) and VITE_ENV (telemetry).
 */
export type AppEnv = 'production' | 'staging' | 'development';

export const APP_ENV: AppEnv = import.meta.env.VITE_ENV ?? 'development';

/**
 * The origin of the API, from ONE source (#664). The images and
 * `docker-compose.yml` set `VITE_API_URL`. A local `npm run dev` has none, so
 * the origin is the local backend. The API client, the socket and the ring feed
 * read this constant. This module imports nothing, so no import cycle can form.
 */
export const API_BASE: string = import.meta.env.VITE_API_URL || 'http://localhost:3000';
